import MultiCelebration from './MultiCelebration';
export default MultiCelebration;